// MATERIAL
import { ButtonBase } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Button = styled(ButtonBase)({
  padding: 3,
  borderRadius: "50%",
});
